// window.setTimeout(function(){
  
// 	var loginLink = document.querySelectorAll('[data-handle="login"] a');
// // var loginLink = document.querySelectorAll('');
//   	loginLink.setAttribute("href", "https://persephanie.shop/pages/logins");

// }, 1000); 

$(function() {
  // Handler for .ready() called.
  	let imageboxesCalc = document.getElementsByClassName('imagebox__media');
//  	let collectionItem = imageboxesCalc.item(0);
// 	let compStyles = window.getComputedStyle(collectionItem);

	let compStyles = window.getComputedStyle(imageboxesCalc);

	let imageboxesCalcWidth = compStyles.getPropertyValue('width');
	console.log(imageboxesCalcWidth);
});
// let para = document.querySelector('p');

// imageboxesCalc.textContent = 'My computed font-size is ' +
//     compStyles.getPropertyValue('font-size') +
//     ',\nand my computed line-height is ' +
//     compStyles.getPropertyValue('line-height') +
//     '.';
// Copy to Clipboard
